import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TopTrending from './components/TopTrending';
import Feed from './components/Feed';
import TodayTimeline from './components/TodayTimeline';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import ArticleModal from './components/ArticleModal';
import BackToTop from './components/BackToTop';
import type { GuaItem } from '@/mocks/guatian';

function applyMeta() {
  const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  document.title = '瓜田网 - 今日新瓜速递｜最新爆料合集 热门大瓜汇总 实时更新';

  setMeta('name', 'description', '瓜田网今日新瓜速递，实时汇总全网热门大瓜与最新爆料合集，覆盖影视、综艺、音乐、商业与圈内趣闻。每日更新吃瓜盘点，第一时间掌握新瓜动态，不错过任何精彩爆料。');
  setMeta('name', 'keywords', '瓜田网,瓜田网今日新瓜,瓜田网最新爆料合集,瓜田网热门大瓜汇总,瓜田网新瓜速递');
  setMeta('name', 'robots', 'index, follow');
  setMeta('name', 'theme-color', '#ec4d5b');
  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:site_name', '瓜田网');
  setMeta('property', 'og:title', '瓜田网 - 今日新瓜速递 最新爆料合集 热门大瓜汇总');
  setMeta('property', 'og:description', '实时汇总全网热门大瓜与最新爆料合集，每日更新吃瓜盘点，第一时间掌握新瓜动态。');
  setMeta('property', 'og:locale', 'zh_CN');
  setMeta('name', 'twitter:card', 'summary');
  setMeta('name', 'twitter:title', '瓜田网 - 今日新瓜速递');
  setMeta('name', 'twitter:description', '实时汇总全网热门大瓜与最新爆料合集，每日更新吃瓜盘点。');

  // 清理旧结构化数据脚本，避免重复
  document.querySelectorAll('script[data-jsonld]').forEach((s) => s.remove());
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-jsonld', 'true');
  script.textContent = JSON.stringify([
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '瓜田网',
      description: '今日新瓜速递，实时汇总热门大瓜与最新爆料合集的娱乐资讯门户。',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '瓜田网 - 今日新瓜速递',
      description: '实时汇总全网热门大瓜与最新爆料合集，每日更新吃瓜盘点。',
      inLanguage: 'zh-CN',
    },
  ]);
  document.head.appendChild(script);
}

export default function Home() {
  const [selected, setSelected] = useState<GuaItem | null>(null);

  useEffect(() => {
    applyMeta();
  }, []);

  return (
    <main className="w-full bg-background-50">
      <Header />
      <Hero />
      <TopTrending />
      <Feed onRead={setSelected} />
      <TodayTimeline />
      <Faq />
      <About />
      <Footer />
      <ArticleModal item={selected} onClose={() => setSelected(null)} />
      <BackToTop />
    </main>
  );
}